/* @flow */
/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
*  Copyright 2018 Adobe
*  All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/

import AnalyticsUtil from './AnalyticsUtil';

export default class NotificationAnalytics {
	ingest: ingestObject;
	analyticsUtils: AnalyticsUtil;

	constructor() {
		this.analyticsUtils = new AnalyticsUtil();
		this.ingest = this.analyticsUtils.ingest;
	}

	/**
	 * [sendToIngest Post to ingest]
	 * @return {[none]}
	 */
	sendToIngest() {
		this.analyticsUtils.checkOptin(this.ingest);
	}

	/**
	 * [initAnalytics Init Ingest]
	 * @return {[none]}
	 */
	initAnalytics() {
		this.ingest.initializeDefaultData();
	}

	/**
	 * [logAnalytics A utility method to set multiple values at once]
	 * @param  {[object of key/value pairs]} dataObject [events]
	 * @return {[none]}
	 */
	logAnalytics(dataObject: Object) {
		dataObject.setEventWorkFlow = this.analyticsUtils.getLocation();
		this.analyticsUtils.logAnalytics(dataObject);
	}

	/**
	 * Post payment failer notification render
	 * @param {*} subCategory
	 */
	postPaymentFailureNotificationRender(errorStatus: string): void {

		this.initAnalytics();

		const data = {
			setEventSubcategory: 'Alert',
			setEventType: 'render',
			setEventSubtype: 'banner',
			setEventErrorType: errorStatus,
			setEventErrorDesc: errorStatus,
			setEventValue: 'Payment Failure',
		};

		this.logAnalytics(data);
		this.sendToIngest();
	}

	postPaymentFailureNotificationAction(errorStatus: string, subType: string): void {

		this.initAnalytics();

		const data = {
			setEventSubcategory: 'Alert',
			setEventType: 'click',
			setEventSubtype: subType,
			setEventErrorType: errorStatus,
			setEventErrorDesc: errorStatus,
			setEventValue: 'Payment Failure',
		};

		this.logAnalytics(data);
		this.sendToIngest();
	}
}
